import { render, staticRenderFns } from "./print-ticket.vue?vue&type=template&id=48a36542&scoped=true&"
import script from "./print-ticket.ts?vue&type=script&lang=ts&"
export * from "./print-ticket.ts?vue&type=script&lang=ts&"
import style0 from "./print-ticket.scss?vue&type=style&index=0&id=48a36542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a36542",
  null
  
)

export default component.exports